import { isCurrencyAmountDto } from 'libs/utils/currency-amount';
export const transformCurrencyAmountDto = _ref => {
  let {
    amount,
    currency_code
  } = _ref;
  return {
    amount,
    currencyCode: currency_code
  };
};
export const transformCurrencyAmountDtoOrString = (dtoOrString, fallbackCurrencyCode) => {
  if (isCurrencyAmountDto(dtoOrString)) return transformCurrencyAmountDto(dtoOrString);
  return {
    amount: dtoOrString,
    currencyCode: fallbackCurrencyCode
  };
};
export const transformNullableCurrencyAmountDto = _ref2 => {
  let {
    amount,
    currency_code
  } = _ref2;

  if (amount && currency_code) {
    return {
      amount,
      currencyCode: currency_code
    };
  }

  return {
    amount: null,
    currencyCode: null
  };
};